import { html, rune, UnsafeHtml, View } from 'rune-ts';
import klass from './CaseSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { getResizedUrl } from '../../../../../shared/util/image';

export type CaseCardProps = {
  title: UnsafeHtml | string;
  imageUrl: string;
  description: UnsafeHtml | string;
};

export class CaseCard extends View<CaseCardProps> {
  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const { title, description, imageUrl } = this.data;

    return html`
      <div class="${klass.case_card}">
        <div class="${klass.case_image}">
          <img
            src="${getResizedUrl({
              url: imageUrl,
              width: 1920 * 2,
              format: 'webp',
              quality: 85,
            })}"
            alt="ip 커머스 예시 이미지"
          />
        </div>
        <div class="${klass.card_title_wrapper}">
          <div class="${klass.card_title} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '20_bold' })}">
            ${title}
          </div>
          <div
            class="${klass.card_description} ${typoPcMo({
              is_mobile,
              pc: '16_medium',
              mo: '14_medium',
            })}"
          >
            ${description}
          </div>
        </div>
      </div>
    `;
  }
}
